<button type="button" class="cfa-plain-button" (click)="setSelectedTemplate(template)" [attr.aria-pressed]="(isSelected$(template.title) | async) ? true : null">
<mat-card class="theme-card__card"
          [ngClass]="{'theme-card__selected': isSelected$(template.title) | async}">
  <div fxLayout="column"
       fxLayoutAlign="space-between center"
       class="theme-card__main-panel">
    <div class="theme-card__card-title">{{template.title}}</div>
    <img alt="Theme Header Image" class="theme-card__header-image" [src]="isMobile ? template.mobileImage: template.image">
    <img alt="Theme Hero Image" class="theme-card__hero-image" [src]="isMobile ? template.mobileImageUrl: template.imageUrl">
  </div>
</mat-card>
</button>

